import React from "react";
import "../style/IndicesTrading.css";

const IndicesTrading = () => {
  return (
    <div className="indices-container">
      {/* Hero Section */}
      <section className="indices-hero">
        <h1 >Indices Trading</h1>
        <p><b>Extrede   offers traders the most popular indices on its powerful<br/><br/> trading platforms.</b></p>
      </section>

    



      <section className="indices-section">
      <h2>Trade Indices with an <br/>Award-Winning Broker</h2>

      <section className="indice-trade">
        
          <div className="indicestext1">The global foreign exchange market is one of the fastest, most liquid and exciting markets. Join thousands of traders who are already trading with extrede   , a multi award-winning global broker, offering over 70 Forex pairs in all the major currencies, 24 hours a day, 5 days a week. All major currency pairs include the US dollar (USD) as either the base or counter currency. Majors include pairs like the GBP/USD, EUR/USD, and USD/JPY.
            <br/><br/>
            extrede    offers you consistently tight spreads, starting from as low as 0.0 pips. We’ve partnered with leading banking and non-banking financial institutions to ensure a deep liquidity pool, so that you get the best available market prices and ultra-low latency order execution.
          </div>

          <div className="indicestext2">
            <h3>What are the benefits of Forex trading?</h3>
            <ul>
            <li>Trading CFD indices allows you to speculate on the direction of movement of the underlying index, without actually having physical ownership of any shares.</li>
           <li>When you trade indices you get to trade both bullish and bearish price moves, giving you greater trading opportunities.</li>
           <li>Competitive leverage means you can choose to increase your exposure with only a small investment from you.</li>
           <li>Remember, CFD indices are a leveraged product which mean that you can also magnify your losses.</li>
           <li>With powerful platforms like MT5, Extrede   offers access to live streaming prices, cutting-edge technical analysis and charting tools.</li>
            
              
            </ul>
          </div>
      </section>
      </section>



      <section  id="good11" className="comm-best-platform">
      <h2 id="good">What is the Best Platform to Trade Forex?</h2>
        <div className="content1">
          <div id="good" className="text-content1">
            
            <p  id="good">Discover the benefits of Forex trading on one of the most powerful trading platforms available, extrede 5 (extrede 5). Available across desktop and mobile platforms, the MetaTrader 5 platform is ready when you are.</p>
            <ul >
              <li id="good">Spreads from 0.0 pips & leverage up to 500:1</li>
              <li id="good">Customisable interface, including colours of technical indicators</li>
              <li id="good">One-click trading</li>
              <li id="good">MarketWatch</li>
              <li id="good">Live price streaming on Live accounts and Demo accounts 128-bits encryption for secure trading</li>
              <li id="good">Expert Advisors (EAs)</li>
              <li id="good">Customisable alerts</li>
              <li id="good">Compatible with iOS, Android, and Mac devices</li>
            </ul>
          </div>
          <div className="image-container">
            <img src="/images/foreex1.png" alt="Trading Platform" />
          </div>
        </div>
       </section>

      <br/><br/>


      <section className="comm-reasons">
        <h2>6 Reasons to Choose extrede   </h2>
        <h4>A Global Forex Broker</h4>

        <div className="comm-grid">

          <div className="comm-card">
          <span className="icon">⚖️</span>
            <h2>Global Regulated Broker</h2>
            <p>Boost your trading experience with a licensed and fully regulated Global comm broker, with multiple awards to their name.</p>
          </div>

          <div className="comm-card">
          <span className="icon">📱</span>
            <h2>Trading Platforms</h2>
            <p>Give your comm trading an edge with robust, feature-rich and easy-to-use MetaTrader 4, MetaTrader 5 and Iress.</p>
          </div>



          <div className="comm-card">
          <span className="icon">⚡</span>
            <h2>Low Latency Execution</h2>
            <p>Get all the available market prices and tight spreads, with ultra-low latency execution and minimal slippage.
            </p>
          </div>
          <div className="comm-card">
          <span className="icon">📈</span>
            <h2>Forex Trading Leverage</h2>
            <p>Leverage of up to 500:1 in over 50 currency pairs and widen your exposure to the global comm markets</p>
          </div>
        </div>
          
      </section>





    

      {/* Index Trading Explanation */}
      <section className="indices-explanation">
        <h2>What is Index Trading?</h2>
        <div className="indicestrading">
        <div className="indicetrade1">
        <p>Stock market indices give the measure of a specific stock market. They represent the value of a group of stocks from a country, and represents the overall, current and historic performance of a specific set of stocks. The calculated value of the stock index is used by investors as an indicator of the current value of their component stocks. Investors can find out the expected returns over time by comparing the current and historic index levels.</p>
        </div>
        <div className="indicetrade2">
            <p>Every stock exchange in the world has a benchmark stock index, while some have several. These baskets of individual stocks are often ranked by independent institutions, like major banks or specialist companies like the FTSE Group or the Deutsche Börse. They also come in different sizes. For instance, the FTSE 100 tracks the share price of the top 100 companies listed on the London Stock Exchange, in terms of market capitalisation. The ASX 200 tracks the share price of the 200 top companies listed on the Australian Securities Exchange (ASX), while the SPI 200 futures contract is a benchmark equity index futures contract, based on the ASX 200 index.</p><br/>
            <p>It is impossible to track all the companies listed on a stock exchange, which is why traders resort to index trading. Through trading indices, they are able to measure the overall performance of the stock market of the country and the economy in general. Traders speculate on the price movements of these financial instruments indices to earn returns when the indices rise in value.</p>
        </div>

        </div>
        
      </section>

      <div className="example">
          <h1>An Example of Indices CFD Trading</h1>
          <p>Suppose you want to trade CFDs, where the underlying asset is the US30, known as ‘’Dow Jones Industrial Average Index ” Let us suppose that the US30 is trading at:</p>
        </div>


        <div className="profitloss">
          <div className="profit">
            <p>You decide to buy 5 contracts of US30 because you think that the US30 price will rise in the future. Your margin rate is 0.5%. This means that you need to deposit 0.5% of the total position value into your margin account.</p>
          <img src="/images/indired.png" alt="loss"/>
           
          </div>

          <div className="loss">
            <p>In the next hour, if the price moves to 35849/35852, you have a winning trade. You could close your position by selling at the current (bid) price of US30 which is 35849</p>
            <img src="/images/indigreen.png" alt="loss"/>
          </div>
         </div>

         <div className="inditext">
            <p>In this case, the price moved in your favor. But, had the price declined instead, moving against your prediction, you could have made a loss. This continuous evaluation of price movements and resultant profit/loss happens daily. Accordingly, it leads to a net return (positive/negative) on your initial margin. In the loss scenario where your Free equity, (account balance + Profit/Loss) falls below the margin requirements (896.6), the broker will issue a margin call. If you fail to deposit the money, and the market moves further against you, when your free equity reach the 50% of your initial margin the contract will be closed at the current market price, known as “stop out”.</p><br/>
            <p>Notice how a small difference in price can offer opportunities to trade? This small difference is known as “pip” or “percentage in point”. For Indices trading, 1 pip is equal to a price increment of 1.0 which is also called an Index point.</p>
         </div>

     

      {/* Benefits */}
      <section className="indices-benefits">
        <h2>Benefits of Index Trading</h2>
        <div className="indi-benifits">
            <div className="indi-benifits1">
                <p>With thousands of stocks trading across different exchanges, stock indices provide an accurate and reliable way to gauge the overall market sentiment. They can also act as benchmarks against individual stock portfolios.</p>
                <p>They can offer exposure to an entire sector in a country. You do not have to perform thorough research on individual companies and other fundamentals. You can simply take a bullish or bearish position, depending on the overall market direction. They reduce the risk of a single company’s performance impacting your entire portfolio.</p>
            </div>
            <div className="indi-benifits2">
                <p>Price movements of indices are smoother, since individual stock performances cannot lead to intense spikes in volatility. But this volatility is sufficient for you to pick out numerous trading opportunities. There is a lot of activity that happens on individual stocks to produce ample index volatility. Indices trading can be suitable to traders of all styles and a variety of trading strategies, since indices reflect the broader effects of economic and political shifts.</p>
            </div>
        </div>
      </section>

      {/* Dividends Adjustments */}
      <section className="indices-dividends">
        <h2>Dividends Adjustments</h2>
        <p>
        If you hold an open Long position on a Cash Index CFD contract that pays a dividend, you will be entitled to an amount equal to the amount based on the number of contracts you hold after the close of the business day before the ex-dividend date.</p>
        <p>Conversely, if you hold an open Short position in a Cash Index CFD which pays a dividend, you will be required to pay an amount based on the number of contracts you hold after the close of the business day before the ex-dividend date. This adjustment may be made either as a cash adjustment into your MetaTrader 5 trading account or included into the end of day swap rate.</p>
      </section>



        <section className="stock-indices-calculation">
        <h2>How are Stock Market Indices Calculated?</h2>
        <p>Financial experts and investors use a range of different methods to calculate Stock Indices. Some of the more popular methods are:</p>
        <div className="method-cards">
            <div className="method-card">
            <h3>Market Capitalisation Weighted Method</h3>
            <p>In this method, the stocks listed on the Index are weighted using the market capitalisation of each company. The S&P 500 and ASX 200 are major Indices that employ this method.</p>
            </div>
            <div className="method-card">
            <h3>The Equal Weighted Method</h3>
            <p>As indicated by its name, equal weightage is given to all the stocks based on their returns. The returns on each stock are calculated, added together and then divided by the total number of stocks on the Index.</p>
            </div>
            <div className="method-card">
            <h3>The Price Weighted Method</h3>
            <p>This model uses the price of applicable stocks to get a weighted average. Stocks with a higher share price are given greater weight, irrespective of market capitalisation. The Dow Jones in the United States uses the price weighted method.</p>
            </div>
        </div>
        </section>


        <section className="unique-indices-section">
      <h2 id="unique-indices-heading">What are the Most Traded Indices?</h2>
      <p id="unique-indices-description">
        Extrede   offers trading in more than a dozen of the world’s
        largest, and most traded global indices.
      </p>
      <div className="unique-indices-container">
        <div className="unique-index-card">
          <img
            src="\images\DowJones.png"
            alt="Dow Jones"
            className="unique-index-logo"
          />
          {/* <h3 className="unique-index-title">DOW JONES</h3> */}
          <p className="unique-index-text">
            The Dow Jones Industrial Average often referred to as ‘the Dow’, is
            a price-weighted index of the 30 largest companies listed on stock
            exchanges in the United States. Salesforce, Boeing, and Walt Disney
            are among the companies that make up the index.
          </p>
        </div>

        <div className="unique-index-card">
          <img
            src="\images\S&P 500.png"
            alt="S&P 500"
            className="unique-index-logo"
          />
          {/* <h3 className="unique-index-title unique-sp500">S&P 500®</h3> */}
          <p className="unique-index-text">
            S&P 500: Tracks the 500 largest US stocks and is weighted by market
            capitalisation. Well-known companies on the S&P 500 include Amazon,
            Apple, Microsoft, Alphabet, and Tesla.
          </p>
        </div>

        <div className="unique-index-card">
          <img
            src="\images\FTSE.png"
            alt="FTSE"
            className="unique-index-logo"
          />
          {/* <h3 className="unique-index-title">FTSE</h3> */}
          <p className="unique-index-text">
            FTSE 100: Is made up of the 100 largest stocks by market
            capitalisation on the London Stock Exchange. It is commonly referred
            to as the Footsie and includes major financial institutions such as
            Lloyds and Barclays.
          </p>
        </div>

        <div className="unique-index-card">
          <img src="\images\ASX.png" alt="ASX" className="unique-index-logo" />
          {/* <h3 className="unique-index-title">ASX</h3> */}
          <p className="unique-index-text">
            ASX 200: Also weighted using market capitalisation, the ASX 200 is
            also maintained by Standard & Poor’s and is the benchmark for equity
            performance in Australia.
          </p>
        </div>
      </div>
    </section>





      {/* Market Movers */}
      <section className="indices-market-movers">
        <h2>How to Identify What Moves an Index's Price</h2>
        <p>Several factors which can influence Indices markets</p>
            <div className="indices-markets">
                <div className="indices-markets1">
                    <p><strong>Movement in its Constituents:</strong> Significant price movement in the stocks included in a particular index is the biggest reason for a change in the value of the index.</p>
                    <p><strong>Economic News and Data:</strong> Market news relating to economic data can affect stock markets and their benchmark Indices. This includes releases of key economic data relating to inflation, unemployment, and futures markets. Key information can be found in the Economic Calendar.</p>
                </div>

                <div className="indices-markets2">
                    <p><strong>Political News:</strong> Elections, changes to monetary policy and trade relations are among the political factors that can impact financial markets and key components of them such as Indices</p>
                    <p><strong>Changes in Composition: </strong>The addition or removal of stocks from an index can cause fluctuations in its value.</p>
                    <p><strong>Sector Specific:</strong> There are a wide range of sector specific Indices such as the NASDAQ 100 which does not include any companies from the financial industry.</p>
                </div>
            </div>

      </section>

      {/* Why Trade Indices */}
      <section className="indices-why-trade">
        <h2>Why Trade Indices ?</h2>
        <div className="indices-trade11">
            <div className="indices-trade1">
                <p><strong>Trading opportunities:</strong> Through CFDs, traders can benefit from both rising and falling Indices prices.</p>
                <p><strong>Hedging:</strong> Indices can be particularly useful for hedging strategies as you can invest in an index of a particular sector. If the portfolio of a trader was made up of stocks from the financial sector, they could trade the NASDAQ 100 to counter any significant price movements in their current portfolio.</p>
            </div>

            <div className="indices-trade2">
                <p><strong>Diversification:</strong> Indices CFDs allow traders to gain exposure to global markets without having to invest in individual stocks. Australian traders can invest in the DAX 30 (Germany) or the Hang Seng (Hong Kong) to gain exposure to other markets.</p>
                <p><strong>Leverage:</strong> The ability to trade using leverage is one of the key attractions of CFD trading. Traders can open positions of a much higher value than the funds available in their trading account. Learn more about Margin Trading.</p>

            </div>
        </div>
      </section>

      {/* How to Trade */}
      <section className="indices-how-trade">
        <h2>How to Trade Indices</h2>
        <p>A simple way to trade Indices is via CFDs using an online trading platform. These financial instruments allow traders to speculate on Indices without owning the underlying asset. FP Markets offers Indices trading through MetaTrader 5, the world’s most popular CFD trading platforms. For further information, check out How to Trade Indices.</p>
      </section>
    </div>
  );
};

export default IndicesTrading;
